import { render, staticRenderFns } from "./ArticleFour.vue?vue&type=template&id=33f9a4e2&scoped=true"
import script from "./ArticleFour.vue?vue&type=script&lang=js"
export * from "./ArticleFour.vue?vue&type=script&lang=js"
import style0 from "./ArticleFour.vue?vue&type=style&index=0&id=33f9a4e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f9a4e2",
  null
  
)

export default component.exports